/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n'
import { applyFilters, addFilter } from '@wordpress/hooks'
import { compose } from '@wordpress/compose'
import { 
	Fragment, 
	useState,
	useEffect
} from '@wordpress/element'
import { i18n } from 'cartzillagb'
import {
	PanelBody, ToggleControl, DateTimePicker, TextControl
} from '@wordpress/components'
import {
	RichText
} from '@wordpress/block-editor'

/**
 * Internal dependencies
 */
import { name } from './index'

/**
 * External dependencies
 */
import {
	BackgroundSettings, ButtonControlsHelper, ButtonEditHelper, ImageUploadPlaceholder
} from '~cartzillagb/components'
import { withTabbedInspector, withClickOpenInspector } from '~cartzillagb/higher-order'
import classnames from 'classnames'

addFilter( 'cartzillagb.deals-block.edit.inspector.style.before', 'czgb/deals-block', ( output, props ) => {
	const { 
		setAttributes,  
	} = props

	const {
		enableBadge,
		enablePretitle,
		enableTitle,
		enableSubtitle,
		enableTimer,
		enableButton,
		badgecolor,
		custombadgecolor,
		custombgcolor,
		bgcolor,
		date,
		daysLabel,
		hoursLabel,
		minsLabel,
		secsLabel
	} = props.attributes


	return (
		<Fragment>
			<PanelBody title={ __( 'Banner Display Settings', i18n ) }>
				<ToggleControl
					label={ __( 'Display Pretitle', i18n ) }
					checked={ enableBadge }
					onChange={ enableBadge => setAttributes( { enableBadge } ) }
				/>
				<ToggleControl
					label={ __( 'Display Pretitle', i18n ) }
					checked={ enablePretitle }
					onChange={ enablePretitle => setAttributes( { enablePretitle } ) }
				/>

				<ToggleControl
					label={ __( 'Display Title', i18n ) }
					checked={ enableTitle }
					onChange={ enableTitle => setAttributes( { enableTitle } ) }
				/>

				<ToggleControl
					label={ __( 'Display Subtitle', i18n ) }
					checked={ enableSubtitle }
					onChange={ enableSubtitle => setAttributes( { enableSubtitle } ) }
				/>
				
				<ToggleControl
					label={ __( 'Enable Timer', i18n ) }
					checked={ enableTimer }
					onChange={ enableTimer => setAttributes( { enableTimer } ) }
				/>

				<ToggleControl
					label={ __( 'Display Button', i18n ) }
					checked={ enableButton }
					onChange={ enableButton => setAttributes( { enableButton } ) }
				/>
			</PanelBody>
			<PanelBody title={ __( 'Color Settings', i18n ) } initialOpen={ false }>
				<BackgroundSettings
					backgroundLabel={ __("Badge Background Color", i18n ) }
					background={ badgecolor !== undefined ? badgecolor : 'badge-soft-primary' }
					prefix='badge-'
					backgroundColor={ custombadgecolor }
					onChangeBackground={ badgecolor => setAttributes( {  badgecolor } ) } 
					onChangeBackgroundColor={ custombadgecolor => setAttributes( { custombadgecolor:  custombadgecolor.hex } ) }
					onRemoveBackground={ () => { setAttributes( { badgecolor: '', custombadgecolor: '' } ) } }
				/>
				<BackgroundSettings
					background={ bgcolor !== undefined ? bgcolor : 'bg-primary' }
					backgroundColor={ custombgcolor }
					onChangeBackground={ bgcolor => setAttributes( { bgcolor, custombgcolor: '' } ) }
					onChangeBackgroundColor={ custombgcolor => setAttributes( { custombgcolor: custombgcolor.hex, bgcolor: '' } ) }
					onRemoveBackground={ () => { setAttributes( { bgcolor: '', custombgcolor: '' } ) } }
				/>
			</PanelBody>
			{ enableTimer && 
				<PanelBody title={ __( 'Timer Settings', i18n ) } initialOpen={ false }>
					<DateTimePicker
						currentDate={ date }
					    onChange={ date => setAttributes( { date } ) }
					    is12Hour={ false }
					/>
					<TextControl
						label={ __('Days Label', i18n) }
						value={ daysLabel }
						onChange={ daysLabel => setAttributes( { daysLabel } ) }
					/>
					<TextControl
						label={ __('Hours Label', i18n) }
						value={ hoursLabel }
						onChange={ hoursLabel => setAttributes( { hoursLabel } ) }
					/>
					<TextControl
						label={ __('Minutes Label', i18n) }
						value={ minsLabel }
						onChange={ minsLabel => setAttributes( { minsLabel } ) }
					/>
					<TextControl
						label={ __('Seconds Label', i18n) }
						value={ secsLabel }
						onChange={ secsLabel => setAttributes( { secsLabel } ) }
					/>
				</PanelBody>
			}

			<PanelBody title={ __( 'Button Settings', i18n ) }initialOpen={ false } >
				<ButtonControlsHelper
					attrNameTemplate="button1%s"
					setAttributes={ setAttributes }
					blockAttributes={ props.attributes }
				/>
			</PanelBody>
		</Fragment>
	)
} )

const edit = props => {
	const { 
		attributes, 
		setAttributes, 
		className
	} = props 

	const {
		badge,
		pretitle,
		enableBadge,
		enablePretitle,
		enableTitle,
		enableSubtitle,
		enableButton,
		badgecolor,
		custombadgecolor,
		title,
		subTitle,
		mediaURL,
		bgcolor,
		custombgcolor,
		date,
		daysLabel,
        hoursLabel,
        minsLabel,
        secsLabel,
        enableTimer
	} = attributes

	let d = new Date(date);
	
	d.setDate(d.getDate());

	function addZero(i) {
		if (i < 10) {
			i = "0" + i;
		}
		
		return i;
	}

	function timeFunction() {
		const h = addZero(d.getHours());
		const m = addZero(d.getMinutes());
		const s = addZero(d.getSeconds());
		const time = ' ' + h + ':' + m + ':' + s;

		return time
	}

	const currentDate = new Date(); // Current date now.

	const initCountdown = () => {

	  let coundown = document.querySelectorAll('.cz-countdown');

	  if (coundown == null) return;

	  for (let i = 0; i < coundown.length; i++) {

	    let endDate = coundown[i].dataset.countdown,
	        daysVal = coundown[i].querySelector('.cz-countdown-days .cz-countdown-value'),
	        hoursVal = coundown[i].querySelector('.cz-countdown-hours .cz-countdown-value'),
	        minutesVal = coundown[i].querySelector('.cz-countdown-minutes .cz-countdown-value'),
	        secondsVal = coundown[i].querySelector('.cz-countdown-seconds .cz-countdown-value'),
	        days, hours, minutes, seconds;
	    
	    endDate = new Date(endDate).getTime();

	    if (isNaN(endDate)) return;

	    setInterval(calculate, 1000);

	    function calculate() {
	      let startDate = new Date().getTime();
	      
	      let timeRemaining = parseInt((endDate - startDate) / 1000);
	      
	      if (timeRemaining >= 0) {
	        days = parseInt(timeRemaining / 86400);
	        timeRemaining = (timeRemaining % 86400);
	        
	        hours = parseInt(timeRemaining / 3600);
	        timeRemaining = (timeRemaining % 3600);
	        
	        minutes = parseInt(timeRemaining / 60);
	        timeRemaining = (timeRemaining % 60);
	        
	        seconds = parseInt(timeRemaining);
	        
	        if (daysVal != null) {
	          daysVal.innerHTML = parseInt(days, 10);
	        }
	        if (hoursVal != null) {
	          hoursVal.innerHTML = hours < 10 ? '0' + hours : hours;
	        }
	        if (minutesVal != null) {
	          minutesVal.innerHTML = minutes < 10 ? '0' + minutes : minutes;
	        }
	        if (secondsVal != null) {
	          secondsVal.innerHTML = seconds < 10 ? '0' + seconds : seconds;
	        }
	        
	      } else {
	        return;
	      }
	    }
	  }
	}

	useEffect( () => {
		initCountdown()
	}, [ props ] )

	const mainClasses = classnames( [
		className,
	], applyFilters( `cartzillagb.${ name.replace( 'czgb/', '' ) }.main-block.classes`, {}, props ) )

	const bgstyle = { backgroundColor: custombgcolor && custombgcolor }


	return (
		<div className={ mainClasses }>
			<section className="container mt-4 mb-grid-gutter">
				<div className={ `rounded-lg py-4 ${ bgcolor ? bgcolor : custombgcolor ? '' : 'bg-faded-info' }` } style={ bgstyle } >
					<div className="row align-items-center">
						<div className="col-md-5">
							<div className="px-4 pr-sm-0 pl-sm-5">
								{ enableBadge &&
									<RichText
										tagName="span"
										className={ `badge ${ badgecolor ? badgecolor : custombadgecolor ? '' : 'badge-danger' }` } 
										value={ badge || 'Limited Offer' }
										onChange={ badge => setAttributes( { badge } ) }
										placeholder={ __( 'Badge', i18n ) }
										keepPlaceholderOnFocus
									/>
								}
								{ enablePretitle && 
									<RichText
										tagName="h3"
										className={ `mt-4 mb-1 font-weight-light text-body` }
										value={ pretitle || 'All New' }
										onChange={ pretitle => setAttributes( { pretitle } ) }
										placeholder={ __( 'Pretitle', i18n ) }
										keepPlaceholderOnFocus
									/>
								}
								{ enableTitle && 
									<RichText
										tagName="h2"
										className={ `mb-1 text-dark` } 
										value={ title || 'Last Gen iPad Pro' }
										onChange={ title => setAttributes( { title : title } ) }
										placeholder={ __( 'Title', i18n ) }
										keepPlaceholderOnFocus
									/>
								}
								{ enableSubtitle && 
									<RichText
										tagName="p"
										value={ subTitle || 'at discounted price. Hurry up!' }
										className={ `h5 font-weight-light text-body` }
										onChange={ subTitle => setAttributes( { subtitle : subTitle } ) }
										placeholder={ __( 'subtitle', i18n ) }
										keepPlaceholderOnFocus
									/>
								}
								{ d.getTime() > currentDate.getTime() && enableTimer &&
									<div className="cz-countdown py-2 h4" data-countdown={ ("0" + (d.getMonth() + 1)).slice(-2) + '/' + ("0" + d.getDate()).slice(-2) + '/' + d.getFullYear() + timeFunction() }>
										<div className="cz-countdown-days">
											<span className="cz-countdown-value"></span>
											<span className="cz-countdown-label text-muted">{ daysLabel }</span>
										</div>
										<div className="cz-countdown-hours">
											<span className="cz-countdown-value"></span>
											<span className="cz-countdown-label text-muted">{ hoursLabel }</span>
										</div>
										<div className="cz-countdown-minutes">
											<span className="cz-countdown-value"></span>
											<span className="cz-countdown-label text-muted">{ minsLabel }</span>
										</div>
										<div className="cz-countdown-seconds">
											<span className="cz-countdown-value"></span>
											<span className="cz-countdown-label text-muted">{ secsLabel }</span>
										</div>
									</div>
								}
								{ enableButton &&
									<ButtonEditHelper
										attrNameTemplate={ `button1%s` }
										setAttributes={ setAttributes }
										blockAttributes={ props.attributes }
									/>
								}
							</div>
						</div>
						<div className="col-md-7">
							<ImageUploadPlaceholder
								imageURL={ mediaURL }
								onRemove={ () => {
									setAttributes( {
										mediaURL: '',
									} )
								} }
								onChange={ ( { url } ) => {
									setAttributes( {
										mediaURL: url,
									} )
								} }
								hasRemove={ false }
								render={ <img src={ mediaURL } alt={ __( 'iPad Pro Offer' ) } /> }
							/>
						</div>
					</div>
				</div>
			</section>
		</div>
	)
}

export default compose(
	withTabbedInspector( [ 'style', 'advanced' ] ),
	withClickOpenInspector( [
		[ '.czgb-button', 'button1' ],
	] )
)( edit )
